<div class="w-full" #pageContainer>
    <div class="bg-card shadow rounded-2xl m-4">
        <div class="flex justify-between p-5 px-8 bg-primary rounded-t-2xl ">
            <div class="text-3xl text-white"><b>
                    {{ wellName }}
                </b></div>
            <div class="self-center" style="color: #dbd3d3;font-size: medium">
                {{ isViewOnly ? 'View' : 'Edit' }} Management Of Change Record
            </div>
        </div>

        <div class="p-12">
            <form [formGroup]="mocForm">
                <div class="grid grid-cols-4 gap-x-8">
                    <mat-form-field class="col-span-2">
                        <mat-label>Field Name</mat-label>
                        <input matInput formControlName="fieldLongName" />
                    </mat-form-field>

                    <mat-form-field class="col-span-2">
                        <mat-label>Platform Name</mat-label>
                        <input matInput formControlName="platformLongName" />
                    </mat-form-field>

                    <mat-form-field class="col-span-2">
                        <mat-label>Well String Name</mat-label>
                        <input matInput formControlName="wellStringShortName" />
                    </mat-form-field>

                    <mat-form-field class="col-span-2">
                        <mat-label>Well Name</mat-label>
                        <input matInput formControlName="wellLongName" />
                    </mat-form-field>

                    <mat-form-field class="col-span-2">
                        <mat-label>String Indicator</mat-label>
                        <input matInput formControlName="stringIndicatorShortName" />
                    </mat-form-field>
                </div>

                <div class="divider my-6"></div>

                <div class="grid grid-cols-4 gap-x-8 mt-4">

                    <mat-form-field class="col-span-4">
                        <mat-label>Title</mat-label>
                        <input matInput formControlName="title" />
                    </mat-form-field>

                    <mat-form-field class="col-span-2">
                        <mat-label>Reference No</mat-label>
                        <input matInput formControlName="refNo" />
                    </mat-form-field>

                    <mat-form-field class="col-span-2">
                        <mat-label>Extension No</mat-label>
                        <input matInput formControlName="extensionNo" />
                    </mat-form-field>

                    <mat-form-field class="col-span-2">
                        <mat-label>Start Date</mat-label>
                        <input matInput formControlName="startDate" />
                    </mat-form-field>

                    <mat-form-field class="col-span-2">
                        <mat-label>End Date</mat-label>
                        <input matInput formControlName="endDate" />
                    </mat-form-field>

                    <mat-form-field class="col-span-2">
                        <mat-label>Key Issue</mat-label>
                        <input matInput formControlName="keyIssues" />
                    </mat-form-field>

                    <mat-form-field class="col-span-2">
                        <mat-label>Stage</mat-label>
                        <input matInput formControlName="stage" />
                    </mat-form-field>

                    <div class="col-span-2 flex flex-col">
                        <mat-label>Approval Status</mat-label>
                        <span class="mt-2 w-48" style="font-size: medium;" [ngClass]="{
                            'successBadge': approvedStatus == mocApprovalStatus.APPROVED,
                            'failedBadge': approvedStatus == mocApprovalStatus.REJECTED,
                            'warningBadge': approvedStatus ==  mocApprovalStatus.PENDING,
                        }">
                            {{ approvedStatus ?? "-" }}
                        </span>
                    </div>

                    <div class="col-span-2 flex flex-col">
                        <mat-label>Status</mat-label>
                        <span class="mt-2 w-48" style="font-size: medium;" [ngClass]="{
                            'idleBadge': status == mocStatus.ACTIVE,
                            'successBadge': status == mocStatus.CLOSED || status == mocStatus.CLOSEOUT,
                            'failedBadge': status == mocStatus.REJECTED || status == mocStatus.CANCELLED,
                            'warningBadge': status == mocStatus.APPROVALPROCESS || status == mocStatus.EXTENSIONAPPROVALPROCESS
                        }">
                            {{ status ?? "-" }}
                        </span>
                    </div>

                    <mat-form-field class="col-span-4 mt-4">
                        <mat-label>Remarks</mat-label>
                        <textarea matInput formControlName="remarks"></textarea>
                    </mat-form-field>
                </div>

                <div class="divider my-6"></div>

                <div class="grid grid-cols-4 gap-x-8 mt-4">
                    <mat-form-field class="col-span-2">
                        <mat-label>Closed Date</mat-label>
                        <input matInput formControlName="closeDate" />
                    </mat-form-field>

                    <mat-form-field class="col-span-2">
                        <mat-label>Requested By</mat-label>
                        <input matInput formControlName="requestedBy" />
                    </mat-form-field>

                    <ng-container *ngIf="approvedStatus == status.APPROVED || approvedStatus == status.CLOSED">
                        <mat-form-field class="col-span-2">
                            <mat-label>Approved By</mat-label>
                            <input matInput formControlName="approvedBy" />
                        </mat-form-field>

                        <mat-form-field class="col-span-2">
                            <mat-label>Approved Date</mat-label>
                            <input matInput formControlName="approvedDate" />
                        </mat-form-field>
                    </ng-container>

                    <mat-form-field class="col-span-2">
                        <mat-label>Updated Date</mat-label>
                        <input matInput formControlName="updatedDate" />
                    </mat-form-field>

                    <mat-form-field class="col-span-2">
                        <mat-label>Updated By</mat-label>
                        <input matInput formControlName="updatedBy" />
                    </mat-form-field>
                </div>
            </form>
        </div>
    </div>
</div>


<div class="fixed bottom-0 right-0 p-4 bg-card w-full">
    <div class="flex justify-end">
        <button class="btn btn-primary mx-2" (click)="location.back()">
            Back
        </button>
        <button class="btn btn-outline btn-default" (click)="save()">
            Save
        </button>
    </div>
</div>